var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataScienceLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 75,
    cy: 75,
    r: 75
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "134%",
    height: "134.7%",
    x: "-17%",
    y: "-15%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 1.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 0.5,
    result: "shadowSpreadOuter3"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    in: "shadowSpreadOuter3",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter3",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 71,
    fill: "#FF983D",
    stroke: "#FFF",
    strokeLinejoin: "square",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#00234A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.421 39.088a2.82 2.82 0 1 1 0-5.64 2.82 2.82 0 0 1 0 5.64zM69.604 88.304a2.82 2.82 0 1 1 0-5.64 2.82 2.82 0 0 1 0 5.64zM71.398 38.063a4.613 4.613 0 1 1 0-9.228 4.614 4.614 0 1 1 0 9.228zM78.063 29.348a3.076 3.076 0 1 1 0-6.153 3.076 3.076 0 0 1 0 6.153zM77.038 76.513a2.563 2.563 0 1 1 0-5.128 2.563 2.563 0 0 1 0 5.128zM81.139 88.304a2.563 2.563 0 1 1 0-5.127 2.563 2.563 0 0 1 0 5.127z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.599 46.102c.24.083.601.152.846.2 1.073.207 3.074.592 3.385 2.983.011.081.016.164.015.247l-.199 18.137a1.688 1.688 0 0 1-.208.798 777.827 777.827 0 0 1-22.718 38.948c-.054.085-1.675 2.568-.73 4.29.881 1.606 3.954 2.49 8.641 2.49h41.737c4.697 0 7.774-.888 8.649-2.5.93-1.72-.68-4.19-.696-4.212a777.75 777.75 0 0 1-22.78-39.016 1.73 1.73 0 0 1-.208-.798c-.065-6.046-.13-12.092-.197-18.137 0-.083.003-.165.013-.246.312-2.392 2.312-2.777 3.386-2.984.244-.048.604-.117.842-.2.104-.462.168-1.057.208-1.632H65.393c.04.583.105 1.173.206 1.632m-11.088 71.424c-6.242 0-10.187-1.413-11.686-4.197-1.856-3.454.854-7.41.96-7.575a783.27 783.27 0 0 0 22.618-38.51c.1-5.817.199-11.635.297-17.453-.193-.082-.592-.158-.868-.211-.833-.16-1.87-.358-2.664-1.179a1.618 1.618 0 0 1-.352-.563c-.636-1.718-.575-4.7-.566-5.034.024-.92.734-1.665 1.588-1.665h23.304c.853 0 1.562.746 1.588 1.665.007.335.069 3.316-.567 5.034a1.579 1.579 0 0 1-.35.561c-.794.823-1.832 1.021-2.664 1.18-.277.054-.675.13-.87.212l.299 17.453a781.978 781.978 0 0 0 22.68 38.576c.063.1 2.771 4.055.917 7.509-1.501 2.784-5.445 4.197-11.688 4.197H54.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.861 92.37c-.004 0-3.148-1.038-6.443.49-2.446 1.137-5.005 4.93-6.522 5.047-2.822.22-8.248-3.881-12.965-5.295-4.89-1.463-9.153-.242-9.159-.242a781.359 781.359 0 0 1-8.263 13.905c-.009.018-.808 1.272-.869 2.56-.02.445.047.894.265 1.294.795 1.463 3.549 2.27 7.743 2.27h37.344c4.195 0 6.947-.807 7.742-2.27.218-.4.287-.846.267-1.29-.062-1.292-.867-2.56-.904-2.616a790.707 790.707 0 0 1-8.236-13.853"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScienceLogo);
export default __webpack_public_path__ + "static/media/data-science-logo.56b7d62f.svg";
export { ForwardRef as ReactComponent };